'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nonMerchandiseIdProductPropInterface = undefined;

var _react = require('react');

var _NonMerchandiseIdProducts = require('pricing-pages-unified-ui/constants/NonMerchandiseIdProducts');

var nonMerchandiseIdProductPropInterface = exports.nonMerchandiseIdProductPropInterface = {
  nonMerchandiseIdProduct: _react.PropTypes.oneOf([_NonMerchandiseIdProducts.SUITE_STARTER, _NonMerchandiseIdProducts.SUITE_PROFESSIONAL, _NonMerchandiseIdProducts.SUITE_ENTERPRISE, _NonMerchandiseIdProducts.BUNDLE])
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/nonMerchandiseIdProductPropInterface.js
// module id = 333
// module chunks = 3 4